import { z } from 'zod';
import type { ProcessCloverCardNotPresentPaymentRequest } from '../../../types/ipg/clover/clover-card-not-present-payment.types';
import { AddressSchema } from '../../../backend_config.types';
import {
    CardTypeSchema,
    TransactionDetailsSchema,
} from '../../payment.schemas';
import { CustomerDetailsSchema } from '../../customer-details.schemas';
import { CloverTokenizationTokenSchema } from './clover-tokenization.schemas';

export const ProcessCloverCardNotPresentPaymentRequestSchema:
    z.ZodType<ProcessCloverCardNotPresentPaymentRequest> = z
        .object({
            terminal_device_uuid: z.string().uuid(),
            single_use_token: CloverTokenizationTokenSchema,
            pan_prefix: z.string().regex(/^\d{6,9}$/),
            card_type: CardTypeSchema,
            card_brand: z.string().min(1),
            card_last4: z.string().regex(/^\d{4}$/),
            cardholder_name: z.string().min(1),
            expiry_date: z.string().regex(/^\d{2}\/\d{2}$/).optional(),
            billing_address: AddressSchema.optional(),
            customer_details: CustomerDetailsSchema,
            stored_for_future_use: z.boolean(),
            transaction_details: TransactionDetailsSchema,
            surcharge_amount: z.number().min(0),
            convenience_fee_amount: z.number().min(0),
            total_fee_amount: z.number().min(0),
            total_amount_paid: z.number().min(0),
        })
        .strict();
